module.exports = __webpack_public_path__ + "img/number5.9c0ddd37.png";